import {ErrorOutline} from '@mui/icons-material';
import {LightTooltip} from '@ui/LightTooltip/LightTooltip';
import i18n from 'i18n';
import {isNil} from 'lodash';

type ErrorAdornmentProps = {
    value: unknown;
    required: boolean;
    title?: string;
};

export const ErrorAdornment = ({value, required, title}: ErrorAdornmentProps) => {
    const validValue = !isNil(value) && value !== '' && value !== false;

    return required && !validValue ? (
        <LightTooltip title={title || i18n.t('requiredField', {ns: 'common'})}>
            <ErrorOutline color='primary' />
        </LightTooltip>
    ) : null;
};
